// extracted by mini-css-extract-plugin
export default {"main-title":"Referral_main-title__C8kni","form-card":"Referral_form-card__NKo9M"};